import {
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';

let registered = false;

/**
 * Registers exactly the chart.js pieces LineChart and BarChart draw with.
 *
 * Not `chart.js/auto`: that pulls in every controller, scale and plugin the
 * library ships — radar, polar area, logarithmic scales, the decimation plugin
 * — and puts all of it in the app bundle for two chart types. Anything added
 * here should be because a component in this folder draws it.
 */
export function registerCharts(): void {
  if (registered) return;

  Chart.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Tooltip,
    Legend,
  );
  registered = true;
}
